import { useCallback, useEffect, useState } from "react";
import { notification } from "antd";

import {
  IInterviewQuestion,
  InterviewQuestionsHttpService,
} from "@/modules/assessments/services/interview-questions-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";

export function useInterviewQuestionBankHook() {
  const [questions, setQuestions] = useState<IInterviewQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchQuestions() {
      try {
        const data = await InterviewQuestionsHttpService.getInterviewQuestions();
        setQuestions(data);
      } catch (error) {
        const message = getFriendlyErrorMessage(error) ?? "Failed to load the interview question bank.";
        notification.error({ message });
      } finally {
        setIsLoading(false);
      }
    }

    fetchQuestions();
  }, []);

  const addQuestion = useCallback(async (body: string) => {
    const question = await InterviewQuestionsHttpService.createInterviewQuestion(body);
    setQuestions((current) => [...current, question]);
    return question;
  }, []);

  return { questions, isLoading, addQuestion };
}
